module.exports = __webpack_public_path__ + "media/justin_5m.936f8509.mp3";